import { Component, Inject, Input, OnInit } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import { Observable, of } from 'rxjs';
import { filter, first, map, switchMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { L10nService } from '@nano/core/l10n';

import { PaymentService } from '@nano/payment/payment.service';
import { Payment, PaymentStatus, PaymentSummary, PaymentType } from '@nano/payment/payment';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { AuthType } from '@nano/core/auth';
import { ApiResponse } from '@nano/core/api';

@UntilDestroy()
@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.less'],
  standalone: false
})
export class PaymentComponent implements OnInit {
  @Input() payment?: Payment;

  readonly PaymentStatus = PaymentStatus;
  readonly PaymentType = PaymentType;

  readonly paymentStatus$: Observable<PaymentStatus>;

  direction: Direction;
  showBack$: Observable<boolean>;
  paymentSummary$: Observable<PaymentSummary>;

  constructor(
    private l10nService: L10nService,
    private paymentService: PaymentService,
    @Inject(NZ_MODAL_DATA) nzData: { payment: Payment }
  ) {
    this.payment = nzData?.payment;
    this.paymentStatus$ = this.paymentService.paymentStatus$;
    this.paymentSummary$ = this.paymentService.paymentSummary$;
    this.l10nService.schema$
      .pipe(
        untilDestroyed(this),
        filter((schema) => !!schema)
      )
      .subscribe((schema) => (this.direction = schema.dir));
  }

  ngOnInit(): void {
    this.showBack$ = this.paymentStatus$.pipe(map((status) => status === PaymentStatus.CREATED || status === PaymentStatus.VALIDATING_ADDRESS));
  }

  prevStep(): void {
    this.checkSecurityMeansType().subscribe(() => {
      this.paymentService.backToInitialStep();
    });
  }

  checkSecurityMeansType(): Observable<ApiResponse<unknown> | null> {
    return this.paymentSummary$.pipe(
      first(),
      switchMap((payment) => {
        const isMobileSignature = (payment.securityMeansType || payment.confirmationType) === AuthType.MOBILE_SIGNATURE;
        if (isMobileSignature) {
          return this.paymentService.deletePaymentOperation$(payment.operationId);
        }
        return of(null);
      })
    );
  }
}
